import { makeGetRequest, makePostRequest } from "./makeRequest";
import appConfig from "../config/app.config";

export const getCronJobsList = async (page = 0, size = 100) => {
  try {
    const response = await makeGetRequest(
      `${appConfig.apiUrl.cronJobsList}?page=${page}&size=${size}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching cron jobs list:", error);
    throw error;
  }
};

export const updateCronJobSchedule = async (
  jobName,
  timestamp,
  immediateTrigger = false,
  updatedState = undefined
) => {
  try {
    const body = {
      jobName,
      immediateTrigger,
    };
    if (!immediateTrigger) {
      body.runAt = timestamp;
    }
    if (updatedState) {
      body.updatedState = updatedState;
    }
    const response = await makePostRequest(
      appConfig.apiUrl.updateCronJobSchedule,
      body
    );
    return response.data;
  } catch (error) {
    console.error("Error updating cron job schedule:", error);
    throw error;
  }
};
